import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import { PublicShareApi, type PublicShareApiRequest, type PublicShareApiResponse } from '../public-share-api';
import type { CreatePublicShareLinkApi, RequestParams, ResponseData } from '../create-public-share-link-api';

@injectable()
export class PublicShareApiImpl extends PsHttpService
    implements PublicShareApi, CreatePublicShareLinkApi
{
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getShareInit(data: PublicShareApiRequest): Promise<PublicShareApiResponse> {
        const res = await this.post<PatSnapSuccessResponseData<PublicShareApiResponse>>({
            url: 'public-share/init',
            data,
            cache: true,
        });
        return res.data;
    }

    async createPublicShareLink(data: RequestParams): Promise<ResponseData> {
        const res = await this.post<PatSnapSuccessResponseData<ResponseData>>({
            url: 'public-share',
            data: data.body,
        });
        return res.data;
    }
}
